import client from './client';

export const getProjectLists = ({ tenant, country, state, cluster }) =>
  client.get('/management/v1/management/project/list', {
    params: {
      tenant,
      ...(country && { country }),
      ...(state && { state }),
      ...(cluster && { cluster })
    }
  });

export const getCountries = () =>
  client.get('/management/v1/management/project/countries/');

export const getStates = country =>
  client.get(`/management/v1/management/project/states/${country}`);

export const createProject = data =>
  client.post('/management/v1/management/project/submitRequest/', data);

export const getProjectDetails = ({ tenant, request_id }) =>
  client.get('/management/v1/management/project/', {
    params: {
      tenant,
      request_id
    }
  });

export const updateProject = data =>
  client.put('/management/v1/management/project/update/', data);

export const deleteProject = ({ tenant, request_id }) =>
  client.delete('/management/v1/management/project/delete/', {
    params: {
      tenant,
      request_id
    }
  });

export const startProcessing = ({ tenant, request_id }) =>
  client.post(
    `/management/v1/management/project/queue/${tenant}/${request_id}`
  );
